import { int } from "../../lib/int"
import { str } from '../../lib/str'
import { Player } from '../../lib/player.js'
import { Content } from '../../components/content'
import { isEmpty } from "lodash"
export class Playlist {
    constructor() {
        this.endpoint = 'playlist'
        this.items = []
        this.count = 1
        ui.select('head').append(ui.element('script',{src : 'https://code.jquery.com/jquery-3.6.0.js'}))
                setTimeout(()=>{
                    ui.select('head').append(ui.element('script',{src : 'https://code.jquery.com/ui/1.13.2/jquery-ui.js'}))
                },1000)
        this.addItem = item => {
            this.count++
            this.reloadPlaylist()
        }
        this.removeItem = index => {
            this.count--
            this.reloadPlaylist()
        }
        this.updateItem = item => {
                this.reloadPlaylist()
        }
        this.setPlaylistInput = ()=>{
            //if(playlist.items.length)
                ui.select('[name="playlist_items"]').value = JSON.stringify(playlist.items)
            //else
                //ui.select('[name="playlist_items"]').value = ''
            //console.log('setPlaylistInput',JSON.parse(ui.select('[name="playlist_items"]').value))
        }
        this.element = ui.element('playlist_items')
        if(ui.element('playlist_items',false)){
            this.sortPlaylist()
        }
        this.company = ui.select('[data-company]') ? ui.select('[data-company]').dataset.company : null
        window.playlist = this
        this.loaderIcon = ui.element('i',{ class : 'fa-duotone fa-2x fa-spinner-third fa-spin loader-icon'})
        this.loader = ui.element('div',{ style:'position: absolute;left: 50%;top: 50%;' },this.loaderIcon)

        this.add_playlist_item = ui.element('add_playlist_item')
        if(this.add_playlist_item){
            this.add_playlist_item_label = this.add_playlist_item.innerHTML
            this.add_playlist_item.disabled = true
            if(this.add_playlist_item.querySelector('.svg-inline--fa'))
                this.add_playlist_item.querySelector('.svg-inline--fa').remove()
            if(this.add_playlist_item.querySelector('span'))
                this.add_playlist_item.querySelector('span').textContent = __('Loading Content..')
            this.add_playlist_item.prepend(ui.element('i',{ class : 'fa-duotone fa-spinner-third fa-spin loader-icon'}))
            this.content = new Content ({ path : '/content', callback : this.previewContent })
            this.backgroundSelect
            this.content.onLoad = ()=>{
                console.log('content.onLoad')
                this.add_playlist_item.disabled = false
                this.add_playlist_item.innerHTML = this.add_playlist_item_label
            }
        }
        this.addContentItem = (playlist_item,item)=>{
            console.log('Add Content Item ', playlist_item,item)
            if(playlist.items[playlist_item.order]){
                console.warn('item '+item.order+' was not added because it already exists')
            }
            ui.select('.form-group h4').setAttribute('style','display:block;')
            item.dataset.content_id = playlist_item.content_id
            item.dataset.name = playlist_item.name
            if(item.type !== 'tickertape'){
                item.dataset.duration = playlist_item.duration
                item.dataset.transition = playlist_item.transition
                item.dataset.fullscreen = playlist_item.fullscreen
                item.dataset.name = playlist_item.name
            }

            item.dataset.order = playlist_item.order

            if(item.type)
                item.dataset.type = playlist_item.type
            if(playlist_item.type !== 'background')
                ui.element('playlist_items').append(item)
            this.reloadPlaylist()
            this.sortPlaylist()
            window.modal.hide()
            ui.select('button[type="submit"]').removeAttribute('disabled')
            //this.count++
        }
        this.loadContentTable = (dir = '/content')=> {
            console.log('Loading Content Table')
            //const item_playlist = {}
            //let list_item
            this.content.browse( item => { // open content
                // console.log(item)
                // if(item_playlist.type === 'tickertape'){
                //     playlist_item_preview.querySelector('[name="playlist_item_duration"]').parentElement.classList.add('d-none')
                //     playlist_item_preview.querySelector('[name="transition"]').classList.add('d-none')
                //     ui.element('fullscreen').parentElement.classList.add('d-none')
                //     playlist_item_preview.querySelector('.duration').classList.add('d-none')
                // }
                //console.log(item) // selected content

            })

        }

        this.boot = [{
            index : [
                () => {
                    ui.select(':[data-action="delete"]').forEach( button => {
                        const row = button.parentElement.parentElement.parentElement,
                            name = row.querySelector('.lead').textContent
                        button.addEventListener('click',(event)=> {
                            event.preventDefault()
                            ui.modal.instance({
                                title : __('Delete') + ' ' + name,
                                centered : true,
                                body : __('Are you sure you want to delete ') + name + '?',
                                buttonSave : __('Delete'),
                                buttonType : 'danger',
                                onClose() {
                                    ui.select('#bootstrapModal .modal-body').innerHTML = ''
                                },
                                onSave() {
                                    button.querySelector('form').submit()
                                }
                            })
                        })
                    })
                }
            ],
            create : [()=>{
                const btn_add_playlist_item = ui.element('add_playlist_item')
                ui.select('.form-group h4').setAttribute('style','display:none;')
                ui.modal.body.style.minHeight = '250px'
                btn_add_playlist_item.addEventListener('click',(event)=>{
                    event.preventDefault()
                    console.log('Loading Content Table at Create')
                    window.playlist.loadContentTable()

                })
                const form = ui.select('.card form')
                form.addEventListener('submit',event=>{
                    event.preventDefault()

                    const playlist = {
                        name : ui.select('[name="name"]').value,
                        clock : ui.select('[name="clock"]').checked ? true : null,
                        template : ui.select('[name="template"]').value,
                        description : ui.select('[name="description"]').value,
                        playlist_items : this.items
                    }
                    //console.log(event.target.action,playlist, this.items)
                    ui.API.post(event.target.action,playlist,()=>window.location.href = '/playlist')
                })
            },
            'previewPlaylist',
            'templateSelect',
            () => this.initToggleEvents(),
            ],
            show : [
                ()=>{
                const form = ui.select('.card form'),
                      playlist_items = JSON.parse(ui.select('[name="playlist_items"]').value),
                      playlist_loader = this.loaderIcon.cloneNode(),
                      contentOnLoad = playlist.content.onLoad

                playlist_items.forEach(item => {
                    if(item.type !== 'tickertape'){
                        playlist.items.push({
                            name : item.name,
                            type : item.type,
                            content_id : item.content_id,
                            transition : item.transition,
                            fullscreen : item.fullscreen,
                            duration : item.duration,
                            order : item.order,
                            source: item.content_id === null ? null : item.content.source
                        })
                    }else{
                        playlist.items.push({
                            name : item.name,
                            type : item.type,
                            content_id : item.content_id,
                            order : item.order,
                            source : item.content.source
                        })
                    }
                })
                console.log('Loading initial table with playlist items')
                console.table(playlist.items)
                //playlist.items = JSON.parse(ui.select('[name="playlist_items"]').value)
                ui.select('[name="playlist_items"]').value = JSON.stringify(playlist.items)
                ui.element('add_playlist_item').addEventListener('click',(event)=>{
                    event.preventDefault()
                    console.log('Loading Content Table for Adding Playlist Item')

                    window.playlist.loadContentTable()
                })

                //ui.element('playlist_items').prepend(playlist_loader)
                setTimeout(()=>{
                    //ui.element('playlist_items').textContent = ''
                },10000)
                playlist.content.onLoad = () => {

                    playlist.items.forEach(item => {
                        this.addPlaylistItem(item,false)
                        this.count++
                    })
                    this.add_playlist_item.disabled = false
                    this.add_playlist_item.innerHTML = this.add_playlist_item_label
                    //this.add_playlist_item.querySelector('.loader-icon').remove()
                    //this.add_playlist_item.prepend(ui.element('i',{ class : 'fa-solid fa-plus'}))
                    //this.add_playlist_item.querySelector('span').textContent = __('Add Playlist Item')

                }
                form.addEventListener('submit',event=>{
                    event.preventDefault()
                    this.items = this.items.map(function(item) {
                        if ('source' in item) {
                            delete item.source
                        }
                        return item;
                    })
                    const playlist = {
                        name : ui.select('[name="name"]').value,
                        clock : ui.select('[name="clock"]').checked ? ui.select('[name="clock"]').checked : null,
                        template : ui.select('[name="template"]').value,
                        description : ui.select('[name="description"]').value,
                        activeDays : {
                            monday: {
                                from: ui.select('#fromMondayTime').value,
                                to: ui.select('#toMondayTime').value
                            },
                            tuesday: {
                                from: ui.select('#fromTuesdayTime').value,
                                to: ui.select('#toTuesdayTime').value
                            },
                            wednesday: {
                                from: ui.select('#fromWednesdayTime').value,
                                to: ui.select('#toWednesdayTime').value
                            },
                            thursday: {
                                from: ui.select('#fromThursdayTime').value,
                                to: ui.select('#toThursdayTime').value
                            },
                            friday: {
                                from: ui.select('#fromFridayTime').value,
                                to: ui.select('#toFridayTime').value
                            },
                            saturday: {
                                from: ui.select('#fromSaturdayTime').value,
                                to: ui.select('#toSaturdayTime').value
                            },
                            sunday: {
                                from: ui.select('#fromSundayTime').value,
                                to: ui.select('#toSundayTime').value
                            },
                        },
                        playlist_items : this.items
                    }
                    ui.API.put(event.target.action,playlist,()=>{
                        ui.toast.show({
                            type : 'success',
                            message : __('Playlist') + ' ' + __('modified successfully.')
                        })
                        //window.location.href = '/playlist'
                    },(error)=>{
                        ui.toast.show({
                            type : 'error',
                            message : __('An error has occured') + ' ' + __('while updating the') + ' ' +  __('Playlist') + '.'+ ' : ' + error
                        })
                    })
                })
                ui.element('remove_background',{click(event){
                    playlist.items.shift();
                    ui.select('[data-playlist]').dataset.playlist = JSON.stringify(playlist.items);
                    ui.element('background-preview-img').removeAttribute('src');
                    ui.element('backgroundContainer').value = '';
                    ui.element('background-preview-img').hidden = true;
                    event.target.classList.add('d-none');
                    ui.element('background-preview-box').removeAttribute('style');
                    ui.element('backgroundSelect').value = '#000000';
                }});


            },id => {
                const distributeModal = ui.element('distributeModal'+id),
                      distributeModalSubmit = distributeModal.querySelector('button[type="submit"]'),
                      distributeModalSelect = ui.select('select[name="player_or_group_id"]',{change(event){
                        if(event.target.value)
                            distributeModalSubmit.disabled = false
                      }})
                distributeModalSubmit.disabled = true
            },'previewPlaylist',
            () => this.initToggleEvents(),
            () => this.activeDaysCheckboxes(this.activeDays),
            () => {
                ui.select(':form-check-input').forEach(checkbox => {
                    checkbox.addEventListener('change', event => {
                        const day = event.target.id
                        event.target.style.display = 'block'
                    })
                })
            },
            ui.element('monday').addEventListener('change', function () {
                if (this.checked) {
                    mondayTime.style.display = 'block';
                    fromMondayTime.value = activeDays.monday.from;
                    toMondayTime.value = activeDays.monday.to;
                } else {
                    mondayTime.style.display = 'none';
                    fromMondayTime.value = '';
                    toMondayTime.value = '';
                }
            }),
            ui.element('tuesday').addEventListener('change', function () {
                if (this.checked) {
                    tuesdayTime.style.display = 'block';
                    fromTuesdayTime.value = activeDays.tuesday.from;
                    toTuesdayTime.value = activeDays.tuesday.to;
                } else {
                    tuesdayTime.style.display = 'none';
                    fromTuesdayTime.value = '';
                    toTuesdayTime.value = '';
                }
            }),
            ui.element('wednesday').addEventListener('change', function () {
                if (this.checked) {
                    wednesdayTime.style.display = 'block';
                    fromWednesdayTime.value = activeDays.wednesday.from;
                    toWednesdayTime.value = activeDays.wednesday.to;
                } else {
                    wednesdayTime.style.display = 'none';
                    fromWednesdayTime.value = '';
                    toWednesdayTime.value = '';
                }
            }),
            ui.element('thursday').addEventListener('change', function () {
                if (this.checked) {
                    thursdayTime.style.display = 'block';
                    fromThursdayTime.value = activeDays.thursday.from;
                    toThursdayTime.value = activeDays.thursday.to;
                } else {
                    thursdayTime.style.display = 'none';
                    fromThursdayTime.value = '';
                    toThursdayTime.value = '';
                }
            }),
            ui.element('friday').addEventListener('change', function () {
                if (this.checked) {
                    fridayTime.style.display = 'block';
                    fromFridayTime.value = activeDays.friday.from;
                    toFridayTime.value = activeDays.friday.to;
                } else {
                    fridayTime.style.display = 'none';
                    fromFridayTime.value = '';
                    toFridayTime.value = '';
                }
            }),
            ui.element('saturday').addEventListener('change', function () {
                if (this.checked) {
                    saturdayTime.style.display = 'block';
                    fromSaturdayTime.value = activeDays.saturday.from;
                    toSaturdayTime.value = activeDays.saturday.to;
                } else {
                    saturdayTime.style.display = 'none';
                    fromSaturdayTime.value = '';
                    toSaturdayTime.value = '';
                }
            }),
            ui.element('sunday').addEventListener('change', function () {
                if (this.checked) {
                    sundayTime.style.display = 'block';
                    fromSundayTime.value = activeDays.sunday.from;
                    toSundayTime.value = activeDays.sunday.to;
                } else {
                    sundayTime.style.display = 'none';
                    fromSundayTime.value = '';
                    toSundayTime.value = '';
                }
            }),
            'templateSelect',
            'backgroundSelect',
            ]
        }]
    }

    // Here you can preview and modify a playlist item, either when it's newly added or edited later.
    previewPlaylist(){
        const previewPlaylistModal = () => {
            ui.modal.instance({
                title : '<i class="fa-duotone fa-clapperboard-play"></i> ' + __('Preview Playlist'),
                fullscreen : true,
                style : '--bs-modal-bg:#000;',
                buttonSave : false,
                buttonCancel : __('Close'),
                btnCloseStyle : 'filter: invert(1);',
                onOpen(){
                    const playerElement = ui.element('div',{ id : 'player' })
                    ui.modal.body.append(playerElement)
                    if(this.player){
                        this.player.play()
                    }else{
                        this.player = new Player({
                            playlist : playlist.items
                        })
                    }
                },
                onClose() {
                    if(this.player) {
                        this.player.stop()
                    }
                }
            })
        }
        ui.element('preview_playlist',{ click(event){
            event.preventDefault()
            previewPlaylistModal()
        }})
    }

    addPlaylistItem(item,modal){
        console.log('Add Playlist Item to list: ', item)
        if(ui.select('#playlist_items [data-order="'+item.order+'"]')) return
        if(item.type !== 'background')
            ui.element('playlist_items').append(this.previewContent(item,modal))
    }

    previewContent(item,modal = true){

        console.log('previewContent')
        console.log('ITEM', item)
        const item_playlist = {},
              content = window.content.items.content[item.id ? item.id : item.content_id],
              playlist_item_preview = ui.template('playlist-item-preview'),
              playlist_item_remove = playlist_item_preview.querySelector('.btn-danger'),
              btn_primary = ui.modal.footer.querySelector('.btn-primary'),
              playlist_item_save = btn_primary.cloneNode(true),
              playlist_item_cancel = ui.modal.footer.querySelector('.btn-secondary').cloneNode(true),
              playlist_item = ui.template('playlist-item'),
              preview = playlist_item_preview.querySelector('.preview'),
              transition_select = playlist_item_preview.querySelector('[name="transition"]'),
              duration_input = playlist_item_preview.querySelector('[name="playlist_item_duration"]'),
              modal_folder = ui.modal.body.querySelector('.table'),
              fullscreen = playlist_item_preview.querySelector('#fullscreen')

        let preview_item,thumb_nail,target

        switch (item.type) {
            case 'image':
                preview_item = ui.element('img',{src : `/uploads/${playlist.company}/${item.id ? item.id : item.content_id }.${content.extension}`,width: '100%',style:'border-radius:0.3rem'})
                thumb_nail = ui.element('img',{src : `/uploads/${playlist.company}/${item.id ? item.id : item.content_id}.${content.extension}`, width: '100%',style:'border-radius:0.3rem'})
                target = 'content'
                break;

            case 'video':
                preview_item = ui.element('video',{width: '100%',style:'border-radius:0.3rem'},ui.element('source',{src : `/uploads/${playlist.company}/${item.id ? item.id : item.content_id }.${content.extension}`}))
                thumb_nail = ui.element('img',{src : `/storage/video-thumbnails/${item.id ? item.id : item.content_id}.jpg`, width: '100%',style:'border-radius:0.3rem'})
                target = 'content'
                break;

            case 'widget':
                // Read player_id from the DOM
                const element = document.getElementById('player-data');
                const player_id = element.dataset.player;
                console.log('PLAYER ID: ', player_id);

                preview_item = ui.element('iframe',{src : item.source+'?id='+player_id, width: '100%', height: '600px', style:'border-radius: 0.3rem'})
                thumb_nail = ui.element('img',{src : `/images/widget-thumbs/${item.name.toLowerCase().replace(/ /g, '_')}.jpg`, width: '100%',style:'border-radius:0.3rem'})
                target = 'widgets'
                break;

            case 'tickertape':
                preview_item = ui.element('img',{src : `/images/tickertape-thumbs/tickertape.jpg`, width: '100%',style:'border-radius:0.3rem'})
                thumb_nail = ui.element('img',{src : `/images/tickertape-thumbs/tickertape_mini.jpg`, width: '100%',style:'border-radius:0.3rem'})
                target = 'tickertapes'
                break;

            case 'folder':
                preview_item = __('Add all files in folder') + ' ' + item.name + ' ' + __('to playlist?')
                target = 'content'
                break;
    
            default:
                break;
        }
        if(item.type === 'video')
            preview_item.controls = true

        if(modal_folder)
            modal_folder.remove()
        else
            ui.modal.body.innerHTML = ''
        ui.modal.title.textContent = item.name

        playlist_item_preview.querySelector('.name').textContent = item.name
        playlist_item.querySelector('.name').textContent = item.name
        playlist_item.dataset.name = item.name
        playlist_item.querySelector('.type').textContent = item.type
        playlist_item.dataset.type = item.type
        playlist_item_preview.querySelector('.type').textContent = item.type
        playlist_item.querySelector('.thumb').append(thumb_nail)

        if(content?.size && content?.resolution){
            playlist_item_preview.querySelector('.size').textContent = content.size
            playlist_item.querySelector('.size').textContent = ' | ' + content.size
            playlist_item_preview.querySelector('.resolution').textContent = content.resolution
            // playlist_item.querySelector('.thumb').append(preview_item.cloneNode())
            playlist_item.querySelector('.resolution').textContent = ' | ' + content.resolution
        }
        if(item.duration){ // duration only needs to be preset for video
            playlist_item_preview.querySelector('.duration').textContent = ' | '+item.duration
            playlist_item_preview.querySelector('[name="playlist_item_duration"]').textContent = item.duration
        }

        //if(item.type !== 'widget' || item.type !== 'tickertape'){
            playlist_item.querySelector('.duration').textContent = item.duration ? item.duration : playlist_item_preview.querySelector('[name="playlist_item_duration"]').textContent
            playlist_item.dataset.duration = item.duration
            playlist_item.querySelector('.transition').textContent = item.transition ? item.transition : transition_select.value
            playlist_item.dataset.transition = item.transition ? item.transition : transition_select.value
            playlist_item.dataset.content_id = item.content_id ? item.content_id : item.id
            playlist_item.dataset.fullscreen = item.fullscreen ? item.fullscreen : 0
            item_playlist.duration = playlist_item_preview.querySelector('[name="playlist_item_duration"]').textContent
            item_playlist.transition = item.transition ? item.transition : transition_select.value
        //}

        // if(item.type === 'widget' || item.type === 'tickertape') {
        //     playlist_item.querySelector('.thumb').append(thumb_nail)
        // }

        if(item.type === 'tickertape'){
            playlist_item.querySelector('.duration').classList.add('d-none')
            playlist_item.querySelector('.transition').classList.add('d-none')

        }
        playlist_item.dataset.order = item.order ? item.order : playlist.count ? playlist.count+1 : 1
        item_playlist.content_id = item.content_id ? item.content_id : item.id
        item_playlist.name = item.name
        //item_playlist.extension = item.extension

        item_playlist.order = item.order ? item.order : playlist.count ? playlist.count+1 : 1
        item_playlist.type = item.type ? item.type : content.type
        item_playlist.fullscreen = item.fullscreen ? item.fullscreen : 0
        // if(item.type === 'widget' || item.type === 'tickertape'){
        //     return addContent()
        // }
        if(item.fullscreen) {
            fullscreen.checked = true
            playlist_item.querySelector('.fullscreen').textContent = __('Full Screen')
        }

        transition_select.value = item_playlist.transition
        duration_input.textContent = item_playlist.duration
        fullscreen.addEventListener('change',event=>{
            item_playlist.fullscreen = event.target.checked ? 1 : 0
            playlist_item.dataset.fullscreen = item_playlist.fullscreen
            if(item_playlist.fullscreen)
                playlist_item.querySelector('.fullscreen').textContent = __('Full Screen')
            else
                playlist_item.querySelector('.fullscreen').textContent = ''
            //console.log(item_playlist)
            if(item_playlist.order <= playlist.items.length)
                playlist.updateItem(item_playlist)
        })
        //playlist_item.querySelector('.row').append(ui.element('div',{class : 'col-md-2 transition'},item.transition))
        playlist_item.dataset.playlistItem = JSON.stringify(item_playlist)

        // if(modal){
        //     ui.modal.footer.querySelector('.btn-primary').removeEventListener('click',addContent)
        //     ui.modal.footer.querySelector('.btn-primary').addEventListener('click',addContent)
        // }

        btn_primary.remove()
        playlist_item_save.classList.remove('d-none')
        ui.modal.footer.append(playlist_item_save)
        playlist_item_save.addEventListener('click',addContent)
        playlist_item.addEventListener('click',()=>{
            const playlist_item_transition = transition_select.value,
                playlist_item_duration = playlist_item_preview.querySelector('[name="playlist_item_duration"]').textContent
            console.log('Open modal to edit Playlist Item')
            console.log('PLAYLIST_ITEM_PREVIEW TO EDIT', playlist_item_preview)
            ui.modal.instance({
                title : item_playlist.name,
                size : 'xl',
                body : playlist_item_preview,
                buttonSave : __('Save'),
                onOpen(){
                    if(item_playlist.type === 'tickertape'){
                        playlist_item_preview.querySelector('[name="playlist_item_duration"]').parentElement.classList.add('d-none')
                        playlist_item_preview.querySelector('[name="transition"]').classList.add('d-none')
                        ui.element('fullscreen').parentElement.classList.add('d-none')
                        playlist_item_preview.querySelector('.duration').classList.add('d-none')
                    }
                    ui.modal.footer.append(playlist_item_remove)
                    playlist_item_remove.addEventListener('click',()=>{
                        playlist_item
                        playlist_item.remove()
                        playlist_item_remove.remove()
                        playlist.removeItem(playlist_item.dataset.order)
                        ui.modal.modal.hide()
                    })
                    ui.modal.footer.querySelector('.btn-primary').classList.remove('d-none')
                    if(!ui.modal.footer.querySelector('.btn-primary'))
                        ui.modal.footer.insertBefore(playlist_item_save,playlist_item_remove)
                    if (ui.modal.footer.querySelector('.btn-info'))
                        ui.modal.footer.querySelector('.btn-info').classList.add('d-none')

                },
                onSave(){
                     ui.modal.modal.hide()
                    //addContent()
                },
                onCancel(){
                    item_playlist.duration = playlist_item_duration
                    item_playlist.transition = playlist_item_transition
                    item_playlist.order = playlist_item.dataset.order
                    //playlist.items[item_playlist.order] = item_playlist
                    //playlist_item.dataset.playlistItem = JSON.stringify(item_playlist)
                    playlist_item.querySelector('.duration').textContent = item_playlist.duration
                    playlist_item.querySelector('.transition').textContent = item_playlist.transition
                    //ui.modal.footer.querySelector('.btn-primary').removeEventListener('click',addContent)
                },
                onClose(){
                    playlist_item.dataset.playlistItem = JSON.stringify(item_playlist)
                    playlist_item.querySelector('.duration').textContent = playlist_item_preview.querySelector('[name="playlist_item_duration"]').textContent
                    playlist_item.querySelector('.transition').textContent = item_playlist.transition
                    playlist_item_remove.remove()
                    playlist_item_save.remove()

                }
            })
        })

        playlist_item_remove.remove()
        preview.append(preview_item) // appends the preview image or video
        playlist_item_preview.querySelectorAll('.duration .dropdown-item').forEach( item => {
            item.addEventListener('click',()=>{
                playlist_item_preview.querySelector('[name="playlist_item_duration"]').textContent = item.dataset.duration
                item_playlist.duration = item.dataset.duration
                item_playlist.order = playlist_item.dataset.order
                playlist_item.querySelector('.duration').textContent = item.dataset.duration
                playlist_item.dataset.playlistItem = JSON.stringify(item_playlist)
                playlist_item.dataset.duration = item.dataset.duration
                //if(playlist.items.length){
                if(item_playlist.order <= playlist.items.length)
                    playlist.updateItem(item_playlist)
                //}
            })
        })

        //ui.modal.body.append(playlist_item_preview)
        if(modal){
            ui.modal.body.querySelector('#'+target).innerHTML = ''
            ui.modal.body.querySelector('#'+target).append(playlist_item_preview)
            console.log('PLAYLIST_ITEM_PREVIEW TO ADD', playlist_item_preview)
            if(item_playlist.type === 'tickertape' || item_playlist.type === 'folder'){
                playlist_item_preview.querySelector('[class="preview"]').classList.add('lead', 'fs-4', 'text-center')
                playlist_item_preview.querySelector('[name="playlist_item_duration"]').parentElement.classList.add('d-none')
                playlist_item_preview.querySelector('[name="transition"]').classList.add('d-none')
                ui.element('fullscreen').parentElement.classList.add('d-none')
                // playlist_item_preview.querySelector('.duration').classList.add('d-none')
            }
            if(item_playlist.type === 'widget' || item_playlist.type === 'tickertape' || item_playlist.type === 'folder'){
                ui.modal.body.querySelector('#item_data').innerHTML = ''
            }
            if (ui.modal.footer.querySelector('.btn-info'))
                ui.modal.footer.querySelector('.btn-info').classList.add('d-none')
        }

        //playlist_item.querySelector('.transition').textContent = transition_select.value
        transition_select.addEventListener('change',event=>{
            item_playlist.transition = transition_select.value
            item_playlist.order = playlist_item.dataset.order
            playlist_item.querySelector('.transition').textContent = transition_select.value
            playlist_item.dataset.transition = transition_select.value
            $(preview_item).effect(  transition_select.value,{},500,()=>{
                setTimeout(function() {
                    $(preview_item).removeAttr( "style" ).hide().fadeIn()
                    }, 1000 )
            })
            //if(playlist.items.length){
            if(item_playlist.order <= playlist.items.length)
                playlist.updateItem(item_playlist)
            //}
        })
        function addContent(event){
            if(event)
                event.currentTarget.removeEventListener('click',addContent)

            if (item.type !== 'folder') {
                playlist.addContentItem(item_playlist,playlist_item)

            } else {
                console.log('This is a folder')
                /*
                    Below code will add all files in the folder to the playlist.
                    Items will be given a default 'fade' transition.
                    Images will have a default duration of 10 seconds.
                */
                // Fetch all files inside folder
                let count = playlist.count
                const content = window.content.items['/content/folder/'+item.id]
                const rows = content.table.querySelectorAll('tbody tr')
                rows.forEach( row => {
                    console.log('ROW: ', row)
                    // Get all relevant information of each playlist item.
                    const name = row.querySelectorAll('a')[1].textContent.replace((/  |\r\n|\n|\r/gm),''),
                        type = row.dataset.contentType,
                        resolution = row.querySelector('.resolution').textContent.replace((/  |\r\n|\n|\r/gm),''),
                        size = row.querySelector('.size').textContent.replace((/  |\r\n|\n|\r/gm),''),
                        extension = row.dataset.contentExtension
                    let duration = '00:00:10'
                    if(row.dataset.contentDuration){
                        duration = row.dataset.contentDuration
                    }
                    // let thumb = type === 'image' || type === 'video' ? row.querySelector('img') : null,
                    // Data to be stored in the playlist_items table                    
                    let item_playlist = {
                        content_id : row.id,
                        duration : duration,
                        fullscreen : 0,
                        name : row.querySelectorAll('a')[1].textContent.replace((/  |\r\n|\n|\r/gm),''),
                        order : count,
                        transition : 'fade',
                        type : row.dataset.contentType
                        // extension : row.dataset.contentExtension,
                        // size : row.querySelector('.size') ? row.querySelector('.size').textContent.replace((/  |\r\n|\n|\r/gm),'') : null,
                        // resolution : row.querySelector('.resolution').textContent.replace((/  |\r\n|\n|\r/gm),''),
                        // thumb : thumb
                    }

                    // Display the new item on the list of playlist-items
                    let playlist_item = ui.template('playlist-item'), preview_item, thumb_nail
                    switch (type) {
                        case 'image':
                            preview_item = ui.element('img',{src : `/uploads/${playlist.company}/${row.id}.${extension}`, width: '100%',style:'border-radius:0.3rem'})
                            thumb_nail = ui.element('img',{src : `/uploads/${playlist.company}/${row.id}.${extension}`, width: '100%',style:'border-radius:0.3rem'})
                            break;           
                        case 'video':
                            preview_item = ui.element('video',{src : `/uploads/${playlist.company}/${row.id }.${extension}`, width: '100%',style:'border-radius:0.3rem'})
                            // preview_item = ui.element('video',{width: '100%',style:'border-radius:0.3rem'},ui.element('source',{src : `/uploads/${playlist.company}/${row.id }.${extension}`}))
                            thumb_nail = ui.element('img',{src : `/storage/video-thumbnails/${row.id}.jpg`, width: '100%',style:'border-radius:0.3rem'})
                            break;
                        default:
                            thumb_nail = null
                            break;
                    }
                    if(type === 'video')
                        preview_item.controls = true
                
                    playlist_item.querySelector('.name').textContent = item_playlist.name
                    playlist_item.dataset.name = item_playlist.name
                    playlist_item.querySelector('.type').textContent = item_playlist.type
                    playlist_item.dataset.type = item_playlist.type
                    playlist_item.querySelector('.size').textContent = ' | ' + row.querySelector('.size').textContent.replace((/  |\r\n|\n|\r/gm),'')
                    playlist_item.querySelector('.thumb').append(thumb_nail)
                    playlist_item.querySelector('.resolution').textContent = ' | ' + row.querySelector('.resolution').textContent.replace((/  |\r\n|\n|\r/gm),'')
                    playlist_item.querySelector('.duration').textContent = row.dataset.contentDuration ? row.dataset.contentDuration : '00:00:10'
                    playlist_item.dataset.duration = row.dataset.contentDuration ? row.dataset.contentDuration : '00:00:10'
                    playlist_item.querySelector('.transition').textContent = 'fade'
                    playlist_item.dataset.transition = 'fade'
                    playlist_item.dataset.content_id = row.id
                    playlist_item.dataset.fullscreen = 0
                    playlist_item.dataset.order = count
                    playlist_item.dataset.playlistItem = JSON.stringify(item_playlist)
            
                    // Enable editing the new item
                    const playlist_item_preview = ui.template('playlist-item-preview'),
                        playlist_item_remove = playlist_item_preview.querySelector('.btn-danger'),
                        playlist_item_save = btn_primary.cloneNode(true),
                        preview = playlist_item_preview.querySelector('.preview'),
                        duration_input = playlist_item_preview.querySelector('[name="playlist_item_duration"]'),
                        transition_select = playlist_item_preview.querySelector('[name="transition"]'),
                        fullscreen = playlist_item_preview.querySelector('#fullscreen')
                    playlist_item_preview.querySelector('.name').textContent = name
                    playlist_item_preview.querySelector('.type').textContent = type
                    playlist_item_preview.querySelector('.resolution').textContent = resolution
                    playlist_item_preview.querySelector('.duration').textContent = ' | '+ duration
                    playlist_item_preview.querySelector('.size').textContent = size

                    // Initial (default) values for duration and transition in edit-modal 
                    duration_input.textContent = duration
                    transition_select.value = 'fade'
 
                    playlist_item.addEventListener('click',()=>{
                        const playlist_item_duration = playlist_item_preview.querySelector('[name="playlist_item_duration"]').textContent,
                            playlist_item_transition = transition_select.value
                        console.log('Open modal to edit Playlist Item from folder')
                        console.log('PLAYLIST_ITEM_PREVIEW TO EDIT ITEM FROM FOLDER', playlist_item_preview)
                        ui.modal.instance({
                            title : item_playlist.name,
                            size : 'xl',
                            body : playlist_item_preview,
                            buttonSave : __('Save'),
                            onOpen(){
                                // if(item_playlist.type === 'tickertape'){
                                //     playlist_item_preview.querySelector('[name="playlist_item_duration"]').parentElement.classList.add('d-none')
                                //     playlist_item_preview.querySelector('[name="transition"]').classList.add('d-none')
                                //     ui.element('fullscreen').parentElement.classList.add('d-none')
                                //     playlist_item_preview.querySelector('.duration').classList.add('d-none')
                                // }
                                ui.modal.footer.append(playlist_item_remove)
                                playlist_item_remove.addEventListener('click',()=>{
                                    playlist_item
                                    playlist_item.remove()
                                    playlist_item_remove.remove()
                                    playlist.removeItem(playlist_item.dataset.order)
                                    ui.modal.modal.hide()
                                })
                                ui.modal.footer.querySelector('.btn-primary').classList.remove('d-none')
                                if(!ui.modal.footer.querySelector('.btn-primary'))
                                    ui.modal.footer.insertBefore(playlist_item_save,playlist_item_remove)
                                if (ui.modal.footer.querySelector('.btn-info'))
                                    ui.modal.footer.querySelector('.btn-info').classList.add('d-none')
                        
                            },
                            onSave(){
                                ui.modal.modal.hide()
                                //addContent()
                            },
                            onCancel(){
                                item_playlist.duration = playlist_item_duration
                                item_playlist.transition = playlist_item_transition
                                item_playlist.order = playlist_item.dataset.order
                                //playlist.items[item_playlist.order] = item_playlist
                                //playlist_item.dataset.playlistItem = JSON.stringify(item_playlist)
                                playlist_item.querySelector('.duration').textContent = item_playlist.duration
                                playlist_item.querySelector('.transition').textContent = item_playlist.transition
                                //ui.modal.footer.querySelector('.btn-primary').removeEventListener('click',addContent)
                            },
                            onClose(){
                                playlist_item.dataset.playlistItem = JSON.stringify(item_playlist)
                                playlist_item.querySelector('.duration').textContent = playlist_item_preview.querySelector('[name="playlist_item_duration"]').textContent
                                playlist_item.querySelector('.transition').textContent = item_playlist.transition
                                playlist_item_remove.remove()
                                playlist_item_save.remove()
            
                            }
                        })
                    })

                    preview.append(preview_item) // appends the preview image or video
            
                    // Select the playing time (videos can be shortened here)
                    playlist_item_preview.querySelectorAll('.duration .dropdown-item').forEach( item => {
                        item.addEventListener('click',()=>{
                            playlist_item_preview.querySelector('[name="playlist_item_duration"]').textContent = item.dataset.duration
                            item_playlist.duration = item.dataset.duration
                            item_playlist.order = playlist_item.dataset.order
                            playlist_item.querySelector('.duration').textContent = item.dataset.duration
                            playlist_item.dataset.playlistItem = JSON.stringify(item_playlist)
                            playlist_item.dataset.duration = item.dataset.duration
                            //if(playlist.items.length){
                            if(item_playlist.order <= playlist.items.length)
                                playlist.updateItem(item_playlist)
                            //}
                        })
                    })
            
                    // Select the transition effect between this and previous playlist item
                    transition_select.addEventListener('change',event=>{
                        item_playlist.transition = transition_select.value
                        item_playlist.order = playlist_item.dataset.order
                        playlist_item.querySelector('.transition').textContent = transition_select.value
                        playlist_item.dataset.transition = transition_select.value
                        $(preview_item).effect(  transition_select.value,{},500,()=>{
                            setTimeout(function() {
                                $(preview_item).removeAttr( "style" ).hide().fadeIn()
                                }, 1000 )
                        })
                        //if(playlist.items.length){
                        if(item_playlist.order <= playlist.items.length)
                            playlist.updateItem(item_playlist)
                        //}
                    })
            
                    // Select the full screen option
                    fullscreen.addEventListener('change',event=>{
                        item_playlist.fullscreen = event.target.checked ? 1 : 0
                        playlist_item.dataset.fullscreen = item_playlist.fullscreen
                        if(item_playlist.fullscreen)
                            playlist_item.querySelector('.fullscreen').textContent = __('Full Screen')
                        else
                            playlist_item.querySelector('.fullscreen').textContent = ''
                        //console.log(item_playlist)
                        if(item_playlist.order <= playlist.items.length)
                            playlist.updateItem(item_playlist)
                    })
            
                    playlist.addContentItem(item_playlist,playlist_item)
                    count++
                })
            }
            ui.modal.modal.hide()
            playlist.content.active = false

        }
        return playlist_item
    }

    toggleDays(e) {
        const checkbox = e.target;
        const timebox = ui.select('#'+checkbox.id+'Time');
        timebox.style.display = checkbox.checked ? "block" : "none";
    }

    initToggleEvents(toggleDays) {
        const days = ['monday', 'tuesday', 'wednesday', 'thursday', 'friday', 'saturday', 'sunday'];
        days.forEach(function(day) {
          const element = document.querySelector('#' + day);
          if (element) {
            element.addEventListener('change', toggleDays);
          }
        });
    }

    sortPlaylist(){
        const playlistElement = ui.element('playlist_items',false)
        ui.sortable.create(playlistElement, {
            handle: '.sort-handle',
            onSort:() => {
                this.reloadPlaylist()
            }
        })
    }

    reloadPlaylist(){
        const background = playlist.items.filter(item => item.type === 'background');
        playlist.items = []
        this.count = 1
        ui.select(':.list-group-item').forEach((item,index) => {
            const list_item = {
                content_id : item.dataset.content_id,
                name : item.dataset.name,
                duration : item.dataset.duration,
                transition : item.dataset.transition,
                fullscreen : item.dataset.fullscreen,
                type: item.dataset.type,
                order : index+1
            }
            playlist.items.push(list_item)
            item.dataset.order = index+1
            item.dataset.playlistItem = JSON.stringify(list_item)
            this.count++

        }) // reset index
        if(background.length){
            playlist.items.unshift(background[0]);
        }
        console.log('Loading table with added playlist item')
        console.table(playlist.items)
        this.setPlaylistInput()
    }

    activeDaysCheckboxes() {
        const app = document.querySelector('#app');
        const activeDays = JSON.parse(app.getAttribute('data-active-days'));
        if(activeDays !== null) {
            // Get the checkboxes and input fields
            const mondayCheckbox = document.querySelector('#monday');
            const mondayTimeDiv = document.querySelector('#mondayTime');
            const fromMondayTimeInput = document.querySelector('#fromMondayTime');
            const toMondayTimeInput = document.querySelector('#toMondayTime');

            const tuesdayCheckbox = document.querySelector('#tuesday');
            const tuesdayTimeDiv = document.querySelector('#tuesdayTime');
            const fromTuesdayTimeInput = document.querySelector('#fromTuesdayTime');
            const toTuesdayTimeInput = document.querySelector('#toTuesdayTime');

            const wednesdayCheckbox = document.querySelector('#wednesday');
            const wednesdayTimeDiv = document.querySelector('#wednesdayTime');
            const fromWednesdayTimeInput = document.querySelector('#fromWednesdayTime');
            const toWednesdayTimeInput = document.querySelector('#toWednesdayTime');

            const thursdayCheckbox = document.querySelector('#thursday');
            const thursdayTimeDiv = document.querySelector('#thursdayTime');
            const fromThursdayTimeInput = document.querySelector('#fromThursdayTime');
            const toThursdayTimeInput = document.querySelector('#toThursdayTime');

            const fridayCheckbox = document.querySelector('#friday');
            const fridayTimeDiv = document.querySelector('#fridayTime');
            const fromFridayTimeInput = document.querySelector('#fromFridayTime');
            const toFridayTimeInput = document.querySelector('#toFridayTime');

            const saturdayCheckbox = document.querySelector('#saturday');
            const saturdayTimeDiv = document.querySelector('#saturdayTime');
            const fromSaturdayTimeInput = document.querySelector('#fromSaturdayTime');
            const toSaturdayTimeInput = document.querySelector('#toSaturdayTime');

            const sundayCheckbox = document.querySelector('#sunday');
            const sundayTimeDiv = document.querySelector('#sundayTime');
            const fromSundayTimeInput = document.querySelector('#fromSundayTime');
            const toSundayTimeInput = document.querySelector('#toSundayTime');

            // Check the values of the "activeDays" object and set the checkboxes and input fields accordingly
            if (activeDays.monday.from && activeDays.monday.to) {
                mondayCheckbox.checked = true;
                mondayTimeDiv.style.display = 'block';
                fromMondayTimeInput.value = activeDays.monday.from;
                toMondayTimeInput.value = activeDays.monday.to;
            }

            if (activeDays.tuesday.from && activeDays.tuesday.to) {
                tuesdayCheckbox.checked = true;
                tuesdayTimeDiv.style.display = 'block';
                fromTuesdayTimeInput.value = activeDays.tuesday.from;
                toTuesdayTimeInput.value = activeDays.tuesday.to;
            }

            if (activeDays.wednesday.from && activeDays.wednesday.to) {
                wednesdayCheckbox.checked = true;
                wednesdayTimeDiv.style.display = 'block';
                fromWednesdayTimeInput.value = activeDays.wednesday.from;
                toWednesdayTimeInput.value = activeDays.wednesday.to;
            }

            if (activeDays.thursday.from && activeDays.thursday.to) {
                thursdayCheckbox.checked = true;
                thursdayTimeDiv.style.display = 'block';
                fromThursdayTimeInput.value = activeDays.thursday.from;
                toThursdayTimeInput.value = activeDays.thursday.to;
            }

            if (activeDays.friday.from && activeDays.friday.to) {
                fridayCheckbox.checked = true;
                fridayTimeDiv.style.display = 'block';
                fromFridayTimeInput.value = activeDays.friday.from;
                toFridayTimeInput.value = activeDays.friday.to;
            }

            if (activeDays.saturday.from && activeDays.saturday.to) {
                saturdayCheckbox.checked = true;
                saturdayTimeDiv.style.display = 'block';
                fromSaturdayTimeInput.value = activeDays.saturday.from;
                toSaturdayTimeInput.value = activeDays.saturday.to;
            }

            if (activeDays.sunday.from && activeDays.sunday.to) {
                sundayCheckbox.checked = true;
                sundayTimeDiv.style.display = 'block';
                fromSundayTimeInput.value = activeDays.sunday.from;
                toSundayTimeInput.value = activeDays.sunday.to;
            }
        }
    }

    templateSelect() {
        const select = ui.select("#templateSelect");
        const image = ui.select("#template-preview-img");
        const playlist = select && select.dataset.playlist ? JSON.parse(select.dataset.playlist) : null;

        if(playlist){
            fetch("/template", {
                headers: {
                    Accept: "application/json"
                }
            })
            .then(res => res.json())
            .then(data => {
                data.forEach(template => {
                    const option = document.createElement("option");
                    option.value = template.name;
                    option.textContent = __(template.name);
                    if (option.value === playlist.template) {
                        option.selected = true;
                    }
                    select.appendChild(option);
                });
    
                const selectedTemplate = select.value.replace(/ /g, "_");
                image.src = `/images/template-thumbs/${selectedTemplate.toLowerCase()}.jpg`;
    
                select.addEventListener("change", function() {
                  const selectedTemplate = select.value.replace(/ /g, "_");
                  image.src = `/images/template-thumbs/${selectedTemplate.toLowerCase()}.jpg`;
                });
            })
            .catch(error => console.error("Error fetching templates:", error));
        } else {
            // Get selected value and construct image path
            console.log("select:", select);
            console.log("select.value:", select.value);
            const selectedValue = select.value;

            const thumbnailPath = '/images/template-thumbs/';
            const selectedTemplate = selectedValue.replace(/ /g, '_').toLowerCase();
            const imagePath = thumbnailPath + selectedTemplate + '.jpg';

            // Update preview image
            image.src = imagePath;

            // Add event listener to update image when user selects a different template
            select.addEventListener("change", function() {
                const selectedValue = select.value;
                const selectedTemplate = selectedValue.replace(/ /g, '_').toLowerCase();
                const imagePath = thumbnailPath + selectedTemplate + '.jpg';
                image.src = imagePath;
            });
        }
    }

    fetchContents() {
        return fetch('/content_select')
            .then(response => {
                if(response.ok) {
                    return response.json()
                }
            })
    }

    backgroundSelect() {
        const container = ui.element('backgroundContainer'),
              backgroundColorSelect = ui.element('backgroundColorSelect'),
              previewImg =  ui.element('background-preview-img'),
              previewContainer = ui.element('background-preview-box'),
              backgroundImgSelect = ui.element('backgroundImgSelect'),
              backgroundPlaylistItem = playlist.items.find(item => item.type === "background") // Find the background item in the playlist items
        if (backgroundPlaylistItem) { // If a background item exists, set the preview image
            ui.API.get('/content_select', data => { // Make the API request to get the data you need
                const backgroundItemId = backgroundPlaylistItem.content_id // find the data using contentId
                const background = data.contents.find(item => item.id === backgroundItemId)
                if(backgroundItemId){
                    previewImg.hidden = false;
                    previewImg.src = `/${background.path}`;
                }
                 // set background image preview
            });

            container.title = backgroundPlaylistItem.name;
            container.value = backgroundPlaylistItem.name;
            if (backgroundPlaylistItem.name.startsWith("#")) {
                backgroundColorSelect.value = backgroundPlaylistItem.name
                previewImg.hidden = true
                previewContainer.style.backgroundColor = backgroundPlaylistItem.name
            }
            ui.element('remove_background').classList.remove('d-none')
        }

        backgroundImgSelect.addEventListener("click", function() {
            selectBackgroundImage();
        });
        function selectBackgroundImage () {
            ui.API.get('/content_select', data => {
                const thumbnails = []
                data.contents.forEach(image => {
                    const path = '/uploads/'+image.company_id+'/'+image.id+'.'+image.content_type.extension,
                        img = ui.element('img', {
                            src : path,
                            width : '200px',
                            style : 'margin:5px;',
                            click(event){
                                // Filter out playlist items with type "background"
                                const filteredItems = playlist.items.filter(item => item.type !== "background")
                                previewImg.hidden = false;
                                // Add the new item to the beginning of the filtered array
                                filteredItems.unshift({
                                    name: image.name,
                                    type: 'background',
                                    content_id: image.id,
                                    transition: null,
                                    fullscreen: true,
                                    duration: null,
                                    order: 0
                                });

                                // Set the new playlist.items to the filtered array
                                playlist.items = filteredItems;
                                const selectedContainer = ui.select('#backgroundContainer')
                                selectedContainer.value = image.name;
                                selectedContainer.title = image.name;
                                previewImg.hidden = false;
                                previewImg.src = path; // update previewImg src here
                                previewContainer.style.backgroundColor = '';
                                ui.element('remove_background').classList.remove('d-none')
                                ui.modal.modal.hide()
                            }
                        })
                    thumbnails.push(img)
                })
                if(!thumbnails.length) {
                    thumbnails = ui.element('p',{ class : 'lead' },__('No images selected'))
                }
                const container = ui.element('div',{ id : 'container'},thumbnails)
                ui.modal.instance({
                    id: "backgroundModal",
                    title: __("Select")+" "+__("Image"),
                    size: "lg",
                    body: container,
                    buttonSave: false,
                })
            })
        }
        function selectBackgroundColor () {
            container.value = backgroundColorSelect.value;
            previewImg.hidden = true;
            previewContainer.style.backgroundColor = backgroundColorSelect.value;
            ui.element('remove_background').classList.remove('d-none')
            // Check if a background item already exists in playlist.items
            const existingBackgroundItem = playlist.items.find(item => item.type === "background");
            if (existingBackgroundItem) {
                // Update the existing background item instead of pushing a new one
                existingBackgroundItem.content_id = null
                existingBackgroundItem.name = backgroundColorSelect.value
            } else {
                // Add the selected image to the playlist
                playlist.items.unshift({
                    name: backgroundColorSelect.value,
                    type: "background",
                    content_id: null,
                    transition: null,
                    fullscreen: true,
                    duration: null,
                    order: 0
                })
                ui.select('[name="playlist_items"]').value = JSON.stringify(playlist.items)
            }
        }

        backgroundColorSelect.addEventListener("change", function() {
            selectBackgroundColor()
        });
    }
}
